import { Component } from '@theme/component';
import { Fleet, selfHeal, shopUrl } from '@theme/fleet';

/**
 * <fleet-page> — full-page fleet manager for /pages/fleet. Same render/event
 * pattern as <fleet-menu> minus the dialog: lists saved machines with set-active
 * (radio), per-row "Shop parts", and remove. Re-renders on `fleet:change`.
 */

const ICON_REMOVE =
  '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg>';

function esc(s) {
  const d = document.createElement('div');
  d.textContent = s == null ? '' : s;
  return d.innerHTML;
}

function escAttr(s) {
  return esc(s).replace(/"/g, '&quot;');
}

class FleetPage extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.listEl = this.querySelector('[data-ref="list"]');
    this.emptyEl = this.querySelector('[data-ref="empty"]');

    this.render = this.render.bind(this);
    // Render + self-heal against Horizon's post-paint section morph.
    this._heal = selfHeal(this, this.render);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._heal) this._heal.stop();
  }

  select(data) {
    const m = this._rows && this._rows[data.i];
    if (m) Fleet.setActive(m.id);
  }

  remove(data) {
    const m = this._rows && this._rows[data.i];
    if (m) Fleet.remove(m.id);
  }

  render() {
    const machines = Fleet.list();
    const activeId = Fleet.getActiveId();
    this._rows = machines;

    if (this.emptyEl) this.emptyEl.hidden = machines.length > 0;
    if (!this.listEl) return;

    this.listEl.innerHTML = machines
      .map((m, i) => {
        const checked = m.id === activeId;
        return `
          <li class="fleet-list__row" role="radio" aria-checked="${checked}">
            <button type="button" class="fleet-list__select" on:click="fleet-page/select?i=${i}">
              <span class="fleet-list__radio" aria-hidden="true"></span>
              <span class="fleet-list__label">${esc(m.label)}</span>
              ${checked ? '<span class="fleet-list__badge">Active</span>' : ''}
            </button>
            <a class="fleet-page__shop-link" href="${escAttr(shopUrl(m))}">Shop parts &rarr;</a>
            <button type="button" class="fleet-list__remove" on:click="fleet-page/remove?i=${i}" aria-label="Remove ${escAttr(m.label)}">${ICON_REMOVE}</button>
          </li>`;
      })
      .join('');
  }
}

if (!customElements.get('fleet-page')) customElements.define('fleet-page', FleetPage);
